import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ServiceHero from '../../components/hero3/servicehero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import aiseo from '../../images/aiseo.png';
import Whatit from '../../components/business-consulting-components/Whatit';
import FaqCustom from '../../components/business-consulting-components/FaqCustom';
import ProjectShowcaseSlider from '../../components/business-consulting-components/Project';
import TestimonialsSection from '../../components/business-consulting-components/TestimonialsSection';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ProcessSection from '../../components/business-consulting-components/ProcessSection';



const Customaiseosolution = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting seo_type'>
                <main className="page_content s2">
                    <Header3 />
                    <ServiceHero top_title={<>Custom AI SEO Solution: <br/> Build the Stack That Fits <br/> Your Growth</>} top_desp={<>One-size-fits-all SEO leaves revenue on the table. Our Custom AI SEO <br/> Solution gives you tailored SEO Solution and Strategy.</>}/>

                    <section className="video_section">
                        <div className="container text-center">
                             <img src={Video} alt="Video" className='video_img'/>
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <span class="sub_heading">WHY CUSTOM AI SEO</span>
                                    <br/>
                                    <br/>
                                    <div class="heading_block">
                                        <h2 class="heading_text">Why “Packages” Don’t Work Anymore</h2>
                                        <p class="heading_description text-dark pe-lg-5">Your buyers don’t “browse Page 1” anymore; they ask AI, compare specs, and request quotes fast.</p>
                                        <ul class="saasai_list mt-4 heading_description">
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Buying journeys are fragmented across Google, Search Engines, and AI answers</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Weak generic keyword lists ignore entity signals and LLM consumption</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Thin or missing content on pages kill late-stage intent</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Content ops can’t scale without a programmatic foundation</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>No AEO/GEO coverage makes you invisible in ChatGPT, Gemini, Perplexity</li>
                                        </ul>

                                        <p class="heading_description text-dark mt-5"><b>Our approach:</b> We engineer pages for humans and AI answers, then attribute outcomes to getting quotation requests, vendor listings, samples shipped, and Closed-Won.</p>
                                    </div>

                                    <button className="read_more btn btn-secondary" style={{marginLeft:'0px'}}>Contact Now</button>

                                </div>
                                <div className="col-lg-6">
                                    <img src={aiseo} alt="aiseo" className='img-fluid'/>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Whatit />
                    <FaqCustom />
                    <ProjectShowcaseSlider />
                    <ProcessSection/>
                    <ToolSection title1={<><b>Free Tool: </b> AEO Visibility Scorecard</>} title2={<>See where your SaaS is (and isn’t) mentioned in AI answers plus the fastest fixes.</>} />
                    <TestimonialsSection />
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Customaiseosolution;
